import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  constructor() {}

  public get issuer() {
    return '3U Vision srl';
  }

  public get application() {
    return '3U Cloud';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }
}
